import type {AuthorType, ChannelId} from "@atg-tillsammans-shared/chat-types";

export enum ChatAllowedAction {
    BLOCK_COMMENTS = "BLOCK_COMMENTS",
    REMOVE_COMMENTS = "REMOVE_COMMENTS",
    UPDATE_CHAT = "UPDATE_CHAT",
    PIN_COMMENT = "PIN_COMMENT",
}

export type ChannelInfo = {
    channelId: ChannelId;
    allowedActions: ChatAllowedAction[];
    memberId: number | null;
    header: string;
    subHeader?: string;
    buttonTitle: string;
    getTag: (messageAuthorType: AuthorType) => string | null;
    mapErrorCode: (id: string | null) => string;
};
